import { Button } from '@heroui/react';
import React from 'react';

export interface PageHeaderAction {
  label: string;
  icon?: React.ReactNode;
  onClick: () => void;
  variant?:
    | 'solid'
    | 'bordered'
    | 'light'
    | 'flat'
    | 'faded'
    | 'shadow'
    | 'ghost';
  color?:
    | 'default'
    | 'primary'
    | 'secondary'
    | 'success'
    | 'warning'
    | 'danger';
}

export interface PageHeaderProps {
  title: string;
  description?: string;
  actions?: PageHeaderAction[];
  className?: string;
}

export const PageHeader: React.FC<PageHeaderProps> = ({
  title,
  description,
  actions = [],
  className = '',
}) => {
  return (
    <div
      className={`flex flex-col sm:flex-row justify-between items-start sm:items-center mb-8 gap-4 ${className}`}
    >
      <div>
        <h1 className="title-large mb-2">{title}</h1>
        {description && <p className="text-default-500">{description}</p>}
      </div>
      {actions.length > 0 && (
        <div className="flex gap-2">
          {actions.map((action, index) => (
            <Button
              key={index}
              color={action.color || 'primary'}
              variant={action.variant || 'solid'}
              startContent={action.icon}
              onPress={action.onClick}
            >
              {action.label}
            </Button>
          ))}
        </div>
      )}
    </div>
  );
};
